import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const CLASSNAMES = {
  h: style.tooltip_horizontal,
  v: style.tooltip_vertical,
};

export function TwoLineLabelTooltip({ labelStyle, label, orientation }) {
  const className = CLASSNAMES[orientation];
  const bottomLineColor = label.bottomLine.backgroundColor || "#dc2626";
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    // Apply triangle color directly to pseudo-element via CSS custom property on the element
    if (containerRef.current) {
      containerRef.current.style.setProperty(
        "--triangle-color",
        bottomLineColor
      );
    }
  }, [bottomLineColor]);

  return (
    <div
      ref={containerRef}
      className={`${className} tooltip_horizontal`}
      style={{
        ...labelStyle,
        "--triangle-color": bottomLineColor,
      }}
    >
      <div
        className={style.top_line}
        style={{
          backgroundColor: label.topLine.backgroundColor || "#2563eb",
          color: label.topLine.textColor || "#ffffff",
        }}
      >
        <p>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            components={{ p: React.Fragment }}
          >
            {label.topLine.text.replace("\\_", "_")}
          </ReactMarkdown>
        </p>
      </div>
      <div
        className={style.bottom_line}
        style={{
          backgroundColor: bottomLineColor,
          color: label.bottomLine.textColor || "#ffffff",
        }}
      >
        <p>
          <ReactMarkdown
            rehypePlugins={[rehypeRaw]}
            components={{ p: React.Fragment }}
          >
            {label.bottomLine.text.replace("\\_", "_")}
          </ReactMarkdown>
        </p>
      </div>
    </div>
  );
}

TwoLineLabelTooltip.propTypes = {
  /**
   * Style for the label
   */
  labelStyle: PropTypes.object,
  /**
   * Two-line label object with topLine and bottomLine
   */
  label: PropTypes.shape({
    topLine: PropTypes.shape({
      text: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string,
      textColor: PropTypes.string,
    }).isRequired,
    bottomLine: PropTypes.shape({
      text: PropTypes.string.isRequired,
      backgroundColor: PropTypes.string,
      textColor: PropTypes.string,
    }).isRequired,
  }).isRequired,
  /**
   * To display the tooltip in horizontal[h]/vertical[v] orientation
   */
  orientation: PropTypes.oneOf(["h", "v"]),
};

TwoLineLabelTooltip.defaultProps = {
  labelStyle: {},
  orientation: "h",
};
